export default {"src":"/intl/_next/static/media/add_card.926200e6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};